import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import Settings from "@/pages/Settings";
import SharedProject from "@/pages/SharedProject";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Invites from "@/pages/Invites";
import Users from "@/pages/Users";
import ProjectCompare from "@/pages/ProjectCompare";
import Jobs from "@/pages/Jobs";
import Discovery from "@/pages/Discovery";
import Integrations from "@/pages/Integrations";
import { Loader2 } from "lucide-react";

function Protected({ children, adminOnly = false }) {
  const { user, ready, isAdmin } = useAuth();
  if (!ready) {
    return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-[#8B949E] font-mono-jb"><Loader2 className="animate-spin mr-2" size={18} /> Loading...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register/:token" element={<Register />} />
      <Route path="/shared/:token" element={<SharedProject />} />
      <Route
        path="/*"
        element={
          <Protected>
            <Shell>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/project/:id" element={<ProjectDetail />} />
                <Route path="/compare" element={<Protected adminOnly><ProjectCompare /></Protected>} />
                <Route path="/jobs" element={<Protected><Jobs /></Protected>} />
                <Route path="/discovery" element={<Protected><Discovery /></Protected>} />
                <Route path="/invites" element={<Protected adminOnly><Invites /></Protected>} />
                <Route path="/integrations" element={<Protected adminOnly><Integrations /></Protected>} />
                <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
                <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
              </Routes>
            </Shell>
          </Protected>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
